export const table = [
  // 0 - 100k
  [[[1409, 520], [1979, 520]], [[1259, 520], [1259, 520]]],
  // 100000.01 - 200k
  [[[1505, 570], [2093, 570]], [[1355, 570], [1943, 570]]],
  // 200000.01 - 300k
  [[[1573, 605], [2179, 605]], [[1423, 605], [2029, 605]]],
  // 300000.01 - 400k
  [[[1591, 630], [2215, 630]], [[1441, 630], [2065, 630]]],
  // 400000.01 - 500k
  [[[1609, 670], [2251, 670]], [[1459, 670], [2101, 670]]],
  // 500000.01 - 600k
  [[[1874, 695], [2636, 695]], [[1724, 695], [2486, 695]]],
  // 600000.01 - 700k
  [[[1874, 750], [2636, 750]], [[1724, 750], [2486, 750]]],
  // 700000.01 - 800k
  [[[1934, 770], [2756, 770]], [[1784, 770], [2606, 770]]],
  // 800000.01 - 900k
  [[[1934, 870], [2756, 870]], [[1784, 870], [2606, 870]]],
  // 900000.01 - 1m
  [[[1934, 920], [2756, 920]], [[1784, 920], [2606, 920]]],
  // 1000000.01 - 1250000
  [[[2804, 920], [3686, 920]], [[2654, 920], [3536, 920]]],
  // 1250000.01+
  [[[2864, 920], [3806, 920]], [[2714, 920], [3656, 920]]],
];

export const SMART_BUYER_FIRST_CALCULATOR_DIVIDER = 100000.01;
export const SMART_BUYER_SECOND_CALCULATOR_DIVIDER = 1250000.01;

export const SMART_BUYER_CALCULATOR_CONDITION_VALUE = 1000000;

export const SMART_BUYER_CALCULATOR_INITIAL_PROPERTY_VALUE = "250000";
